// extracted by mini-css-extract-plugin
export default {"button":"Button_button__+YGbv","default":"Button_default__c2V07","outline":"Button_outline__LPUN4","destructive":"Button_destructive__xT84L"};